<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>项目</el-breadcrumb-item>
        <el-breadcrumb-item>分销推广</el-breadcrumb-item>
        <el-breadcrumb-item>推广人员</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">推广商品</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="ProductCreateDialog = true"
          >新增推广商品</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="商品名称"
          prop="name"
        >
          <el-input
            v-model="query.product_name"
            placeholder="输入商品名称"
            @input="fetchList(true)"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="商品类型"
          prop="ref_type"
        >
          <el-select
            v-model="query.product_type"
            clearable
            placeholder="请选择"
            style="width: 150px"
            @change="fetchList(true)"
          >
            <el-option
              v-for="item in filter.refTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="推广等级"
          prop="ref_type"
        >
          <el-select
            v-model="query.promoter_level"
            clearable
            placeholder="请选择"
            style="width: 150px"
            @change="fetchList(true)"
          >
            <el-option
              v-for="item in filter.level"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">商品列表</h3>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            type="index"
            label="序号"
            width="50px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="goods_name"
            label="商品类型"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ formatRef_type(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="商品名称"
            width="300px"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div style="text-align:left;">{{scope.row.product_name}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="product_name"
            label="售价"
            width="150px"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{scope.row.product_price}}元
            </template>
          </el-table-column>
          <el-table-column
            prop="product_name"
            label="推广佣金"
            width="150px"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.charge_rate&&scope.row.charge_amount">{{scope.row.charge_amount}}元</span>
              <span v-else-if="scope.row.charge_rate">{{scope.row.charge_rate*100}}%</span>
              <span v-else-if="scope.row.charge_amount">{{scope.row.charge_amount}}元</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="product_name"
            label="邀请奖励"
            width="150px"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.charge_rate_parent&&scope.row.charge_amount_parent">{{scope.row.charge_amount_parent}}元</span>
              <span v-else-if="scope.row.charge_rate_parent">{{scope.row.charge_rate_parent*100}}%</span>
              <span v-else-if="scope.row.charge_amount_parent">{{scope.row.charge_amount_parent}}元</span>
            </template>
          </el-table-column>
          <el-table-column
            label="推广等级"
            width="100px"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                size="mini"
                :type="scope.row.promoter_level==1?'':'success'"
              >{{scope.row.promoter_level==1?'仅推广员':'全员推广'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="推广话术"
            width="300"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div style="text-align:left;">{{scope.row.promoter_desc}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            width="120px"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="修改时间"
            width="120px"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.update_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="160px"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="openEdit(scope.row)"
              >编辑</el-link>
              <el-link
                type="primary"
                :underline="false"
                @click="openText(scope.row)"
              >文案</el-link>
              <el-link
                type="danger"
                :underline="false"
                @click="handleToRemove(scope.row)"
              >删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <ProductCreate
      :visible="ProductCreateDialog"
      @close="ProductCreateDialog=false"
      @submit="fetchList()"
    />
    <ProductEdit
      :visible="ProductEditDialog"
      @close="ProductEditDialog=false"
      :content="ProductEditContent"
      @submit="fetchList()"
    />
    <ProductText
      :visible="ProductTextDialog"
      :content="ProductTextContent"
      @close="ProductTextDialog=false"
      @submit="fetchList()"
    />
  </div>
</template>

<script>

import { marketingChargelist, marketingChargeDelete } from "@/api/distribution";
import ProductCreate from '@/components/dialog/distribution/ProductCreate.vue'
import ProductEdit from '@/components/dialog/distribution/ProductEdit.vue'
import ProductText from '@/components/dialog/distribution/ProductText.vue'
export default {
  components: {
    ProductCreate,
    ProductEdit,
    ProductText
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      filter: {
        status: [
          { label: "已审核", value: "" },
          { label: "未审核", value: "1" },
          { label: "未提交", value: "0" },
        ],
        refTypes: [
          { label: "课程", value: "1" },
          { label: "题库", value: "2" },
          { label: "专栏", value: "3" },
          { label: "资料", value: "4" },
        ],
        level: [
          { label: "仅推广员", value: "1" },
          { label: "全员推广", value: "0" },
        ],
      },
      ProductCreateDialog: false,
      ProductEditDialog: false,
      ProductEditContent: {},
      ProductTextDialog: false,
      ProductTextContent: {},
    };
  },
  created() {
    this.fetchList()
  },
  methods: {
    fetchList(isReset = false) {
      if (isReset) {
        this.$set(this.query, "pageIndex", 1);
      }
      marketingChargelist(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchList();
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    openEdit(row) {
      this.ProductEditContent = JSON.parse(JSON.stringify(row))
      this.ProductEditDialog = true
    },
    openText(row) {
      this.ProductTextContent = JSON.parse(JSON.stringify(row))
      this.ProductTextDialog = true
    },
    handleToRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        marketingChargeDelete({ id: row.id }).then(res => {
          this.$message.success(`删除成功`)
          this.fetchList()
        })
      }).catch(() => { })
    },
    formatRef_type(row) {
      const obj = {
        0: "无",
        1: "课程",
        2: "题库",
        3: "专栏",
        4: "资料",
        5: "文章",
        6: "学长",
        7: "联报",
      };
      return obj[row.product_type] || "";
    },
  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
</style>
